import { render } from "./UpdateCurrencys.vue?vue&type=template&id=d73c6f00"
import script from "./UpdateCurrencys.vue?vue&type=script&lang=js"
export * from "./UpdateCurrencys.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__